"use client";

import React from "react";

interface FormModalsProps {
  SaveTemplateModal: React.ComponentType<any> | undefined;
  isSaveTemplateModalOpen: boolean;
  onCloseSaveTemplateModal: () => void;
  formData: Record<string, unknown>;
}

/**
 * Renders template save modal
 */
export const FormModals = React.memo(function FormModals({
  SaveTemplateModal,
  isSaveTemplateModalOpen,
  onCloseSaveTemplateModal,
  formData,
}: FormModalsProps) {
  return (
    <>
      {/* Save Template Modal */}
      {SaveTemplateModal && (
        <SaveTemplateModal
          formData={formData}
          isOpen={isSaveTemplateModalOpen}
          onClose={onCloseSaveTemplateModal}
        />
      )}
    </>
  );
});
